/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener('variant:changed', function(event) {
//   let availableWrapper = document.getElementsByClassName('product-form__inventory-wrapper')[0];
//   let variantId = event.detail.variant.id;
//
//   if(event.detail.variant.available){
//     if( variantsPolicyConfig[variantId].qty < 1 && variantsPolicyConfig[variantId].policy === 'continue' ) {
//       availableWrapper.innerHTML = '';
//       availableWrapper.innerHTML = '' +
//         '<div class="inventory-warehouse">\n' +
//         '  <p class="inventory-warehouse_title">' + window.themeVariables.strings.product_at_warehouse + ':</p>\n' +
//         '  <p class="inventory-warehouse_item">\n' +
//         '    <svg focusable="false" width="16" height="11" class="icon icon--store-availability-in-stock   " viewBox="0 0 16 11" role="presentation">\n' +
//         '      <path fill="none" d="M1.5 4.2L6.37411 9L14.5 1" stroke="#168342" stroke-width="2"></path>\n' +
//         '    </svg>' + window.themeVariables.strings.at_warehouse_delivery + '</p>\n' +
//         '</div>';
//     } else {
//       availableWrapper.innerHTML = '';
//       availableWrapper.innerHTML = '' +
//         '<div class="inventory-available">\n' +
//         '  <p class="inventory-available_title">' + window.themeVariables.strings.product_in_stock + ':</p>\n' +
//         '  <p class="inventory-available_item">\n' +
//         '    <svg focusable="false" width="16" height="11" class="icon icon--store-availability-in-stock   " viewBox="0 0 16 11" role="presentation">\n' +
//         '      <path fill="none" d="M1.5 4.2L6.37411 9L14.5 1" stroke="#168342" stroke-width="2"></path>\n' +
//         '    </svg>' + window.themeVariables.strings.in_stock_delivery + '</p>\n' +
//         '    <p class="inventory-available_item">\n' +
//         '    <svg focusable="false" width="16" height="11" class="icon icon--store-availability-in-stock   " viewBox="0 0 16 11" role="presentation">\n' +
//         '      <path fill="none" d="M1.5 4.2L6.37411 9L14.5 1" stroke="#168342" stroke-width="2"></path>\n' +
//         '    </svg>' + window.themeVariables.strings.in_stock_local_pickup + '</p>\n' +
//         '</div>';
//     }
//   } else {
//     availableWrapper.innerHTML = '';
//   }
// });
let chargingCheckboxOn = false;
let chargingProductId
let chargingProductVariantId
let protectorCheckboxOn = false;
let protectorProductId
let protectorProductVariantId
let caseCheckboxOn = false;
let caseProductId
let caseProductVariantId
document.addEventListener('variant:changed', function(event) {
  let variantTitle = document.getElementsByClassName('product-meta_variant-title')[0];

  variantTitle.innerHTML = event.detail.variant.title.split('/').join('-');

  const price = event.detail.variant.price;
  const priceInCurrency = price / 100;
  const formattedPrice = priceInCurrency.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const displayPrice = `${formattedPrice} kr`;

  let variantPrice = document.getElementsByClassName('price--large')[0];
  variantPrice.innerHTML = displayPrice;

});

document.addEventListener('variant:changed', function(event) {
  let vippsButtonContainer = $('.product-form__payment-container');

  if (!event.detail.variant.available) {
    vippsButtonContainer.addClass('vippsHidden');
    $('[data-product-add-to-cart-button]')
    .removeClass('button--primary')
    .addClass('button--ternary')
    .attr('disabled', 'disabled')
    .html(window.themeVariables.strings.productFormSoldOut)
  } else {
    vippsButtonContainer.removeClass('vippsHidden');
    $('[data-product-add-to-cart-button]')
    .addClass('button--primary')
    .removeClass('button--ternary')
    .removeAttr('disabled', 'disabled')
    .html(window.themeVariables.strings.productFormAddToCart)
  }
});

document.addEventListener('variant:changed', function(event) {
  let stockNotificationContainer = $('.stock-notifications-wrapper');

  if (event.detail.variant.available && (parseInt(window.variantsAvailability[event.detail.variant.id]) <= parseInt(stockNotificationContainer.data('stock-breakpoint')))) {
    if(parseInt(window.variantsAvailability[event.detail.variant.id]) < 1) {
      setTimeout(() => {
        if( $('.shopify-product-form').hasClass('hideBuyNowBtn')) {
          stockNotificationContainer.removeClass('hidden')
          $('.stock-notification').removeClass('low').removeClass('normal').addClass('preorder').html(window.themeVariables.strings.product_preorder)
        } else {
          stockNotificationContainer.removeClass('hidden')
          $('.stock-notification').removeClass('low').addClass('normal').html(window.themeVariables.strings.product_available.charAt(0).toUpperCase() + window.themeVariables.strings.product_available.slice(1))
        }
      }, 1000)
    } else {
      stockNotificationContainer.removeClass('hidden')
      $('.stock-notification').removeClass('normal').addClass('low').html(window.variantsAvailability[event.detail.variant.id] + ' ' + window.themeVariables.strings.product_available)
    }

  } else {
    if( event.detail.variant.available ) {
      stockNotificationContainer.removeClass('hidden')
      $('.stock-notification').removeClass('low').addClass('normal').html(window.variantsAvailability[event.detail.variant.id] + ' ' + window.themeVariables.strings.product_available)
    } else {
      if( !stockNotificationContainer.hasClass('hidden') ) {
        stockNotificationContainer.addClass('hidden')
      }
    }
  }
});

document.addEventListener('variant:changed', function(event) {
  let swatchBlocks = $('.product-form__option-selector');
  let currentVariant = event.detail.variant;

  swatchBlocks.each((index, swatchBlock) => {
    let blockType = $(swatchBlock).data('selector-type');
    let currentOption = $(swatchBlock).find('input:checked');
    let notSelectedOptions = $(swatchBlock).find('input:not(:checked)')

    switch(index) {
      case 0:
        notSelectedOptions.each((optionIndex, option) => {
          let optionVariants = window.productVariants.filter(variant => {
            return variant.title.includes($(option).val()) && variant.option2 === currentVariant.option2 && variant.option3 === currentVariant.option3
          });

          let priceDifference = (event.detail.variant.price - optionVariants[0].price) * -1;
          let positive = priceDifference > 0

          if(blockType === 'block') {
            currentOption.siblings('label').find('.variant-swatch__price-difference').addClass('checked').html('');
            $(option).siblings('label').find('.variant-swatch__price-difference').removeClass('checked').html((positive ? '+' : '') + (priceDifference / 100) + 'kr');
          } else if (blockType === 'variant-image'){
            // currentOption.siblings('.variant-swatch__price-difference').html('+0kr');
            // $(option).siblings('.variant-swatch__price-difference').html((priceDifference / 100) + 'kr');
          }
        })
        break;
      case 1:
        notSelectedOptions.each((optionIndex, option) => {
          let optionVariants = window.productVariants.filter(variant => {
            return variant.title.includes($(option).val()) && variant.option1 === currentVariant.option1 && variant.option3 === currentVariant.option3
          });

          let priceDifference = (event.detail.variant.price - optionVariants[0].price) * -1;
          let positive = priceDifference > 0

          if(blockType === 'block') {
            currentOption.siblings('label').find('.variant-swatch__price-difference').addClass('checked').html('');
            $(option).siblings('label').find('.variant-swatch__price-difference').removeClass('checked').html((positive ? '+' : '') + (priceDifference / 100) + 'kr');
          } else if (blockType === 'variant-image'){
            // currentOption.siblings('.variant-swatch__price-difference').html('+0kr');
            // $(option).siblings('.variant-swatch__price-difference').html((priceDifference / 100) + 'kr');
          }
        })
        break;
      case 2:
        notSelectedOptions.each((optionIndex, option) => {
          let optionVariants = window.productVariants.filter(variant => {
            return variant.title.includes($(option).val()) && variant.option1 === currentVariant.option1 && variant.option2 === currentVariant.option2
          });

          let priceDifference = (event.detail.variant.price - optionVariants[0].price) * -1;
          let positive = priceDifference > 0

          if(blockType === 'block') {
            currentOption.siblings('label').find('.variant-swatch__price-difference').addClass('checked').html('');
            $(option).siblings('label').find('.variant-swatch__price-difference').removeClass('checked').html((positive ? '+' : '') + (priceDifference / 100) + 'kr');
          } else if (blockType === 'variant-image'){
            // currentOption.siblings('.variant-swatch__price-difference').html('+0kr');
            // $(option).siblings('.variant-swatch__price-difference').html((priceDifference / 100) + 'kr');
          }
        })
        break;
    }
  })
});

document.addEventListener('variant:changed', function(event) {
  let labelList = $('.product-meta__label-list');
  let variant = event.detail.variant;

  // Clear existing labels
  labelList.empty();

  // If variant is not available, show sold out label
  if (!variant.available) {
    labelList.html('<span class="label label--subdued">' + window.themeVariables.strings.collectionSoldOut + '</span>');
  }
  // If variant has a compare_at_price, show discount label
  else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    let savings;
    let discountMode = window.themeVariables.settings.discountMode;

    if (discountMode === 'percentage') {
      savings = Math.round(((variant.compare_at_price - variant.price) * 100.0) / variant.compare_at_price) + '%';
    } else {
      let savingsAmount = (variant.compare_at_price - variant.price) / 100;
      savings = savingsAmount.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
    }

    let discountLabel = window.themeVariables.strings.collectionDiscount.replace('@savings@', savings);
    labelList.html('<span class="label label--highlight">' + discountLabel + '</span>');
  }
});

document.addEventListener('click', function(event) {
  if(event.target.classList.contains('product-more-info-button')){
    document.querySelectorAll('.shopify-section--faq')[0].scrollIntoView({behavior: 'smooth'});
    document.querySelectorAll('.faq__item:first-child .collapsible-toggle')[0].click();
  }
})

document.addEventListener('cart:updated', function(event) {
  $('.rebuyCartWidget').html('');
  $('.rebuyCartWidget').html('<div data-rebuy-id="30689"></div>');
  if(window.Rebuy){
    Rebuy.init();
  }
});

document.addEventListener('rebuy.add', function(event){
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

document.addEventListener('bndlr:bundle_added_to_cart', function(e) {
  setTimeout(() => {
    document.getElementById('mini-cart').open = true;
  }, 200)
});



$(document).ready(function(){

  // function languageChangedCallback() {
  //   let langCode = Weglot.getCurrentLang();
  //   let langName = Weglot.getLanguageName(langCode);
  //
  //   $('.language-selector-toggle').removeClass('active en no sv da').addClass(langCode);
  //   $('.language-selector-toggle .lang').html(langName);
  //   $('.language-selector-languages').removeClass('active');
  // }
  //
  // if(Weglot.initialized){
  //   languageChangedCallback()
  // }
  //
  // $('.language-selector-toggle').on('click', function(e) {
  //   $(this).toggleClass('active');
  //   $(this).siblings('.language-selector-languages').toggleClass('active');
  // })
  //
  // $('.language-item').on('click', function(e) {
  //   let langCode = $(this).data('lang');
  //   Weglot.switchTo(langCode);
  // })
  //
  // Weglot.on("languageChanged", languageChangedCallback);

  $('#terms').on('change', function(){
    if($(this).is(":checked")) {
      $('.cart__checkout-button').removeAttr("disabled");
    } else {
      $('.cart__checkout-button').attr("disabled", "disabled");
    }
  });
  $(document).on('change', '#terms-slide', function(){
    if($(this).is(":checked")) {
      $('.checkout-button').removeAttr("disabled");
    } else {
      $('.checkout-button').attr("disabled", "disabled");
    }
  });

  $('.bundle-content-trigger').on('click', function() {
    document.getElementById('bundleContent').scrollIntoView({behavior: 'smooth', block: 'start'});
  })

})

$(document).ready(function(){
  $('.charging-package-product-input').on('change', function (e) {
    if($(this).is(':checked')){
      chargingCheckboxOn = true
      chargingProductVariantId = Number($(this).attr('data-product-variant-id'))
    }
  })
  $('.protector-product-input').on('change', function (e) {
    if($(this).is(':checked')){
      protectorCheckboxOn = true
      protectorProductVariantId = Number($(this).attr('data-product-variant-id'))
    }
  })
  $('.case-product-input').on('change', function (e) {
    if($(this).is(':checked')){
      caseCheckboxOn = true
      caseProductVariantId = Number($(this).attr('data-product-variant-id'))
    }
  })
})

